import {useSnackbar} from "notistack";
import {useCallback} from "react";
import EventBus from "../services/event-bus";

export default function useAlerts() {
    const {enqueueSnackbar} = useSnackbar();

    return useCallback((message, options) => {
        switch (options.variant) {
            case 'error':
            case 'warning':
                EventBus.dispatch('ALERT', {message, options});
                break;
            default:
                enqueueSnackbar(message, {autoHideDuration: 1500, ...options});
                break;
        }
    }, [enqueueSnackbar]);
}